import { connect } from 'react-redux'

import DeleteContactListView from './DeleteContactListView.jsx';
import { deleteContactList } from 'src/legacy/redux/actions/contactList.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.id;
  var contactList = state.legacyRootReducer.contactLists.contactList[id];
  
  return {
    contactLists: state.legacyRootReducer.contactLists.items,
    contactList: contactList ? contactList.item : null,
    deleting: contactList ? contactList.deleting : false,
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteContactList: (id) => {
      return dispatch(deleteContactList(id));
    }
  }
}

const DeleteContactListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteContactListView)

export default withUseHooks(DeleteContactListContainer);